module.exports = __webpack_public_path__ + "static/media/upload-icon.0935ead7.svg";